export default __webpack_public_path__ + "images/ba9fcd537f9ec3ee11803f5fe19ee6e4-opera_small.webp";